import { render, staticRenderFns } from "./contact_app.vue?vue&type=template&id=b1bba768&"
import script from "./contact_app.vue?vue&type=script&setup=true&lang=ts&"
export * from "./contact_app.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./contact_app.vue?vue&type=style&index=0&id=b1bba768&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports